export const MAX_TITLE_LENGTH = 80;
export const MAX_BODY_LENGTH = 500;
export const MAX_CHANNELS_PER_SUBSCRIPTION = 10;
export const MAX_ACTIVE_SUBSCRIPTIONS = 100;
export const PUSH_TTL_SECONDS = 60 * 60;
export const PUSH_CONCURRENCY = 20;
export const PUSH_TIMEOUT_MS = 5_000;

export const SELF_RATE_LIMIT = { limit: 5, windowMs: 60_000 };
export const SELF_HOURLY_LIMIT = { limit: 30, windowMs: 60 * 60_000 };
export const CHANNEL_RATE_LIMIT = { limit: 3, windowMs: 60_000 };
export const CHANNEL_HOURLY_LIMIT = { limit: 20, windowMs: 60 * 60_000 };
export const IP_HOURLY_LIMIT = { limit: 30, windowMs: 60 * 60_000 };

export const PUBLIC_PRECACHE = [
  "/",
  "/manifest.webmanifest",
  "/icons/icon-192.svg",
  "/icons/icon-512.svg",
];
